// extracted by mini-css-extract-plugin
module.exports = {"landing_container":"LandingPage_landing_container__1kQrg"};